import { resolveApiBase } from "./apiBase.js";

export const TENANT_ID = "cheepsweepz";

function readSiteOrigin() {
  if (typeof window !== "undefined" && window.location?.origin) {
    return window.location.origin;
  }
  return process.env.REACT_APP_SITE_URL || "https://cheepsweepz.shop";
}

/** Whether this axios config targets the Mansion / CheepSweepz API. */
export function isApiRequest(config) {
  const raw = String(config?.url || config?.baseURL || "");
  if (!raw) return false;
  if (raw.includes("/api/")) return true;
  try {
    const base = resolveApiBase({
      hostname: typeof window !== "undefined" ? window.location.hostname : "",
      configured: process.env.REACT_APP_BACKEND_URL,
    });
    return raw.startsWith(base);
  } catch {
    return false;
  }
}

/** Attach tenant, origin, and bearer headers without clobbering AxiosHeaders. */
export function applyApiAuthHeaders(config, token = "") {
  if (!config.headers) {
    config.headers = {};
  }

  const setHeader = (key, value) => {
    if (!value) return;
    if (typeof config.headers.set === "function") {
      if (!config.headers.get(key)) config.headers.set(key, value);
      return;
    }
    if (!config.headers[key]) config.headers[key] = value;
  };

  setHeader("X-Tenant-ID", TENANT_ID);
  setHeader("X-Site-Origin", readSiteOrigin());
  setHeader("X-DHC-Hub", "digitalhustlerscaribbean.com");

  if (token) {
    const existing =
      (typeof config.headers.get === "function" && config.headers.get("Authorization")) ||
      config.headers.Authorization;
    if (!existing) {
      setHeader("Authorization", `Bearer ${token}`);
    }
  }

  return config;
}
